import useInquiryPartnership from '@/pages/inquiry/hooks/useInquiryPartnership';

const PartnershipPage = () => {
	const { formData, isSubmitEnabled, inquiryPsClickSubmit, handleInputChange } = useInquiryPartnership();

	return (
		<section id="" className="sub-content">
			<div className="sub-inner">
				<p className="page-desc">올인원 비즈니스웨어 스텔라 서비스에 대해 궁금하신 사항을 남겨주세요!</p>

				<div className="form form-set">
					<div className="form-group">
						<legend className="blind">스텔라 서비스 문의사항 전송을 위한 사용자 정보 입력</legend>
						<div className="form-box">
							<label htmlFor="companyName">회사명</label>
							<input
								id="companyName"
								type="text"
								name="companyName"
								placeholder="회사명을 입력하세요."
								value={formData.companyName}
								onChange={handleInputChange}
							/>
						</div>
						<div className="form-box">
							<label htmlFor="userName">이름</label>
							<input
								id="userName"
								type="text"
								name="userName"
								placeholder="이름을 입력하세요."
								value={formData.userName}
								onChange={handleInputChange}
							/>
						</div>
						<div className="form-box">
							<label htmlFor="userNumber">연락처</label>
							<input
								id="userNumber"
								type="text"
								name="userNumber"
								placeholder="연락처를 입력하세요."
								maxLength={11}
								value={formData.userNumber}
								onChange={handleInputChange}
							/>
						</div>
						<div className="form-box">
							<label htmlFor="userMail">이메일</label>
							<input
								id="userMail"
								type="email"
								name="userMail"
								placeholder="이메일을 입력하세요."
								value={formData.userMail}
								onChange={handleInputChange}
							/>
						</div>
						<div className="form-box">
							<label htmlFor="userInquiry">문의 내용</label>
							<textarea
								id="userInquiry"
								name="userInquiry"
								placeholder="궁금하신 문의 내용을 남겨주시면 무엇이든 답변해 드리겠습니다."
								value={formData.userInquiry}
								onChange={handleInputChange}></textarea>
						</div>

						<div className="terms-box">
							<div className="chkbox-box">
								<input
									type="checkbox"
									name=""
									id="inquiryAgree"
									checked={formData.inquiryAgree}
									onChange={handleInputChange}
								/>
								<label htmlFor="inquiryAgree">개인정보 수집 및 이용동의 (필수)</label>
							</div>

							<div className="table table-col">
								<table>
									<thead>
										<tr>
											<th>수집 및 이용목적</th>
											<th>수집하는 개인정보 항목</th>
											<th>보유 및 이용 기간</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td className="bullet-dash">
												<p className="bullet">제휴 내용 확인 및 처리</p>
											</td>
											<td className="bullet-dash">
												<p className="bullet">회사명, 이름, 연락처, 이메일</p>
											</td>
											<td className="bullet-dash">
												<p className="bullet">
													동의일로부터 1년
													<br />
													(단, 요청 시 삭제)
												</p>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>

						<div className="button-group align-center">
							<button
								id="inquiryPsBtn"
								className="btn primary"
								onClick={inquiryPsClickSubmit}
								disabled={!isSubmitEnabled}>
								문의하기
							</button>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default PartnershipPage;
